import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import BackgroundClose from '../BackgroundClose/BackgroundClose';
import MyAlertsTooltip from './MyAlertsTooltip';
import MyAlertsModalAction from '../../actions/MyAlertsModalAction';
import { selectMyAlertsModalSlotWrapper } from '../../selectors/PdpNameSpaceSelector';

const MyAlertsTooltipWrapper = (props) => {
    const closeModal = () => {
        props.actions.updateMyAlertsSlot({ slot: null, sourceMiniPDP: props.fromMiniPDP });
    };

    const isModalOpen = props.slot && props.myAlertsModalSlot === props.slot;

    return (
        <BackgroundClose
            closeModal={closeModal}
            isModalOpen={isModalOpen}
            render={() =>
                isModalOpen ? (
                    <MyAlertsTooltip
                        closeMyAlert={closeModal}
                        isSwatchTooltip={props.isSwatchTooltip}
                        fromMiniPDP={props.fromMiniPDP}
                    />
                ) : (
                    ''
                )
            }
        />
    );
};

const mapStateToProps = (state, ownProps) => ({
    myAlertsModalSlot: selectMyAlertsModalSlotWrapper(ownProps.fromMiniPDP)(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...MyAlertsModalAction }, dispatch),
});

MyAlertsTooltipWrapper.propTypes = {
    actions: PropTypes.object,
    myAlertsModalSlot: PropTypes.object,
    slot: PropTypes.object,
    isSwatchTooltip: PropTypes.bool,
    fromMiniPDP: PropTypes.bool,
};

MyAlertsTooltipWrapper.defaultProps = {
    actions: {},
    myAlertsModalSlot: null,
    slot: null,
    isSwatchTooltip: false,
    fromMiniPDP: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAlertsTooltipWrapper);
